<template>
  <v-container>
    <v-form ref="form" v-model="valid" class="mx-5 px-5">
      <v-text-field v-model="name" :rules="nameRules" label="Beer Name" required></v-text-field>

      <!-- <v-autocomplete
        v-model="breweryId"
        :items="breweries"
        :loading="breweryBusy"
        :search-input.sync="searchBrewery"
        label="Brewery"
        placeholder="Start typing to Search"
        item-text="title"
        item-value="breweryId"
        hide-no-data
        :rules="breweryRules"
      ></v-autocomplete> -->
      <v-combobox
          v-model="brewery"
          :items="breweries"
          :search-input.sync="searchBrewery"
          label="Brewery"
          placeholder="Start typing to Search"
          item-text="title"
          item-value="breweryId"
          required
          :rules="breweryRules"
        ></v-combobox>

      <v-autocomplete
        v-model="selectedStyles"
        :items="styles"
        :loading="stylesBusy"
        :search-input.sync="searchStyles"
        label="Style(s)"
        placeholder="Start typing to Search"
        item-text="title"
        item-value="styleSlug"
        required
        multiple
        chips
        small-chips
        hide-no-data
        @change="searchStyles = ''"
        cache-items
        :rules="styleRules"
      ></v-autocomplete>

      <img v-if="image != null" :src="image" width="auto" height="200px" />
      <input type="file" ref="pictureFile" accept="image/*" class="hidden"  @change="onImageUpload">
      <input type="file" ref="pictureCamera" accept="image/*" capture="camera" class="hidden" @change="onImageUpload">

      <v-btn color="primary" class="mr-4" @click="$refs.pictureCamera.click()">
        <v-icon left>mdi-camera</v-icon>
        Take Picture
      </v-btn>

      <v-btn color="primary" class="mr-4" @click="$refs.pictureFile.click()">
        <v-icon left>mdi-file</v-icon>
        Select Picture
      </v-btn>

      <v-text-field v-model="abv" label="Alcohol Content (ABV)" required :rules="abvRules"></v-text-field>

      <v-text-field v-model="ibu" label="Bitterness (IBU)" optional></v-text-field>

      <v-text-field v-model="ebc" label="Color (EBC)" optional></v-text-field>

      <v-text-field v-model="temp" label="Serving Temp (°C)" optional></v-text-field>

      <v-textarea
        v-model="description"
        name="description"
        label="Description"
        optional
      ></v-textarea>

      <v-text-field v-model="webpage" label="Webpage" optional></v-text-field>
      <v-text-field v-model="barcode" label="Barcode" optional></v-text-field>

      <v-btn color="success" class="mr-4" @click="onAddBeer">
      Add Beer
      </v-btn>

      <v-btn color="error" class="mr-4" @click="onCancel">
      Cancel
      </v-btn>
    </v-form>

    <v-overlay :value="uploading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-container>
</template>

<script>

export default {
  name: 'BeerAdd',
  props: {
    collectionId: {
      type: Number,
      default: 0,
    },
    newName: {
      type: String,
      default: '',
    },
    newBarcode: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    debounce: null,
    valid: false,
    name: '',
    nameRules: [(v) => (v && v.length >= 3) || 'Minimum 3 chars'],
    breweryBusy: false,
    breweryRules: [(v) => !!v || 'Brewery is required'],
    searchBrewery: '',
    breweries: [],
    breweryId: 0,
    brewery: '',
    searchStyles: '',
    selectedStyles: [],
    styleRules: [(v) => (v.length > 0) || 'Style is required'],
    styles: [],
    stylesBusy: false,
    imagefile: null,
    image: null,
    abv: null,
    abvRules: [(v) => !!v || 'ABV is required'],
    ibu: null,
    ebc: null,
    temp: null,
    description: '',
    webpage: '',
    barcode: '',
    uploading: false,
  }),
  methods: {
    onAddBeer() {
      if (!this.$refs.form.validate()) {
        // not valid, todo notify with snackbar
      } else {
        this.uploading = true;

        if (typeof this.brewery === 'object') {
          this.breweryId = this.brewery.breweryId;
          this.brewery = '';
        } else {
          this.breweryId = 0;
        }

        const data = {
          name: this.name,
          breweryId: this.breweryId,
          brewery: this.brewery,
          style: this.selectedStyles,
          abv: this.abv,
          ibu: this.ibu,
          ebc: this.ebc,
          temp: this.temp,
          description: this.description,
          webpage: this.webpage,
          image: this.image,
          collectionId: this.collectionId,
          barcode: this.barcode,
        };

        this.$webConn.request('app2_add_beer', data).then((result) => {
          if (result.beerId) {
            this.uploading = false;
            // ok
            if (this.collectionId) {
              this.$root.$emit('CollectionChanged', this.collectionId);
            }
            this.$router.back();
            this.$destroy();
          }
        }).catch((error) => {
          alert(error.message);
          this.uploading = false;
          this.$destroy();
        });
      }
    },
    onImageUpload(e) {
      const files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        return;
      }
      this.imagefile = files[0];
      const reader = new FileReader();
      reader.readAsDataURL(this.imagefile);
      reader.onload = (f) => {
        this.image = f.target.result;
      };
    },
    onCancel() {
      this.$router.back();
      this.$destroy();
    },
    onCordovaTakePicture() {

      // console.log(window);
      // window.CameraPreview.takePicture({ width: 640, height: 640, quality: 85 }, (base64PictureData) => {
      //   this.image = 'data:image/jpeg;base64,' + base64PictureData;
      // }, (error) => {
      //   console.log(error);
      // });
      // navigator.camera.getPicture((imageData) => {
      //   this.image = 'data:image/png;base64,' + imageData;
      // }, (error) => {
      //   console.log(error);
      // },
      // {
      //   quality: 80,
      //   encodingType: 1, // PNG
      //   destinationType: 0, // DATA_URL base64 image
      //   targetWidth: 1024,
      //   targetHeight: 1024,
      //   correctOrientation: true,
      //   allowEdit: true,
      // });
    },
  },
  mounted() {
  },
  created() {
    // console.log('Created ' + this.collectionId);
    this.name = this.newName;
    this.barcode = this.newBarcode;
  },
  watch: {
    searchBrewery(val) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        if (val && val.length > 2) {
          const data = {
            search: val,
          };

          this.breweryBusy = true;

          this.$webConn.request('app2_search_brewery', data).then((result) => {
            this.breweries = result.breweries;
            this.breweryBusy = false;
          }).catch((error) => {
            alert(error.Message);
          });
        }
      }, 500);
    },
    searchStyles(val) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        if (val && val.length > 1) {
          const data = {
            search: val,
          };

          this.stylesBusy = true;

          this.$webConn.request('app2_search_style', data).then((result) => {
            this.styles = result.styles;
            this.stylesBusy = false;
          }).catch((error) => {
            alert(error.Message);
          });
        }
      }, 500);
    },
  },
};

</script>
